import * as types from '@store/types'
import request from '@queries'
import ConfigQuery from '@queries/Config'
import ConfigLoggedQuery from '@queries/ConfigLogged'
import lightness from 'lightness'

const defaultFavicon = require('../../assets/img/favicon_kaledo.png')

const state = {
  config: {},
  signIn: { partners: [] },
  companies: [],
  companyName: '',

  colors: {
    primary: '',
    secondary: '',
    tertiary: ''
  }
}

const getters = {
  [types.CONFIG_MAIN]: ({ config }) => ({ ...config }),

  [types.CONFIG_COLORS]: ({ colors }) => ({ ...colors }),

  [types.CONFIG_SIGNIN]: ({ signIn }) => ({ ...signIn }),

  [types.CONFIG_COMPANY_NAME]: ({ companyName }) => companyName,

  [types.CONFIG_COMPANIES]: ({ companies }) => [...companies]
}

const mutations = {
  [types.CONFIG_MAIN]: (state, payload) => {
    state.config = {
      open_in_self_tab: payload.open_in_self_tab,
      allowed_banks: payload.allowed_banks,
      block_banks_at_cashback: payload.block_banks_at_cashback,
      title: payload.title,
      favicon: payload.favicon,
      logo: payload.logo,
      support_link: payload.support_link,
      url: payload.url,
      custom_script: payload.custom_script,
      slug: payload.slug,
      email: payload.email,
      has_api_access: payload.has_api_access,
      has_initial_page: payload.has_initial_page,
      has_geolocation_access: payload.has_geolocation_access,
      main_category: payload.main_category,
      marketplace_client_url: payload.marketplace_client_url,
      mobile_logo: payload.mobile_logo,
      logout: payload.logout,
      logout_url: payload.logout_url,
      logo_no_width: payload.logo_no_width,
      save_users_email: payload.save_users_email,
      generic_app: payload.generic_app,
      has_request_partners: payload.has_request_partners,
      withdraw_award: payload.withdraw_award,
      withdraw_engagement: payload.withdraw_engagement
    }

    document.querySelector('link[rel*=\'icon\']').href = payload.favicon ? payload.favicon : defaultFavicon

    // add SEO title
    document.title = payload.title || 'Clube Kaledo'

    // add SEO Canonical
    const canonical = document.createElement('link')
    canonical.rel = 'canonical'
    canonical.href = payload.url
    document.head.appendChild(canonical)

    // add SEO meta description
    const description = document.createElement('meta')
    description.name = 'description'
    description.content = payload.intro
    document.head.appendChild(description)
  },

  [types.CONFIG_SIGNIN]: (state, { signIn: colors, ...payload }) => {
    if (payload) {
      state.signIn = {
        ...state.signIn,
        background: payload.background,
        partners: payload.partners,
        logo: payload.signInLogo,
        intro: payload.intro,
        developedByConvenia: payload.developedByConvenia
      }
    }

    if (colors) {
      state.signIn = {
        ...state.signIn,
        mainButton: colors.mainButton,
        mainButtonText: colors.mainButtonText,
        mainText: colors.mainText,
        divisors: colors.divisors,
        or: colors.or,
        secondaryButton: colors.secondaryButton,
        forgotPassword: colors.forgotPassword,
        negativeFeedback: colors.negativeFeedback
      }

      Object.keys(colors)
        .filter(key => !!colors[key] && colors[key].length >= 3)
        .forEach(key => document.body.style.setProperty(`--signIn-${key}`, colors[key]))
    }
  },

  [types.CONFIG_COLORS]: (state, payload) => {
    if (payload) {
      state.colors = { ...payload }
      const defaults = { primary: '#565F7D', secondary: '#B7BBC8', tertiary: '#f5a623' }

      Object.keys(payload)
        .filter(key => !!payload[key])
        .forEach((key) => {
          const fallback = defaults[key]
          const color = payload[key].length > 3 && payload[key]
          document.body.style.setProperty(`--color-${key}`, color || fallback)
          document.body.style.setProperty(`--color-${key}-9`, lightness(color || fallback, +10))
          document.body.style.setProperty(`--color-${key}-8`, lightness(color || fallback, +20))
          document.body.style.setProperty(`--color-${key}-5`, lightness(color || fallback, +50))
        })
    }
  },

  [types.CONFIG_COMPANIES]: (state, payload) => {
    state.companies = [...payload]
  },

  [types.CONFIG_COMPANY_NAME]: (state, payload) => {
    state.companyName = payload
  }
}

const actions = {
  [types.CONFIG]: ({ commit, getters }, { document, name, exp }) => {
    const auth = getters[types.AUTH]

    commit(types.AUTH, { ...auth, expiresAt: exp * 1000 })
    commit(types.USER, { document, name })
  },

  [types.CONFIG_FETCH]: async ({ commit }, isLogged) => {
    const query = isLogged ? ConfigLoggedQuery : ConfigQuery
    const { data: { data: { companyConfig } } } = await request(query, {}, true)
    const { colors, ...config } = companyConfig || {}
    if (companyConfig) {
      const permissions = companyConfig.permissions ? companyConfig.permissions : null
      const company = {
        permissions,
        brands: companyConfig.brands,
        logo: companyConfig.logo,
        url: companyConfig.url
      }
      commit(types.COMPANY, company)
    }

    commit(types.CONFIG_MAIN, config || {})

    if (colors) commit(types.CONFIG_COLORS, colors)

    commit(types.CONFIG_SIGNIN, config || {})
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/config.js